import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haMultiPatsharePipe'
})
export class HaMultiPatsharePipePipe implements PipeTransform {

  transform(doctorData: any[], searchTermDoctormulti: string): any[]{
    if (!doctorData || !searchTermDoctormulti) { return doctorData; }
    return doctorData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermDoctormulti.toLowerCase().trim()) !== -1
     




    );
  }

}
